angular.
module("dx.webapp.droparea").
directive("dxDroparea", function dropareaDirective() {
	"use strict";

	var droppableOverTargetClass = "droppable-overTarget";
	var dropareaHoveringClass = "droparea-itemHovering";

	return {
		restrict: "A",
		scope: {
			droparea: "=",
			dropareaCallback: "&",
			dropareaDataKey: "@?",
		},
		link: link,
	};

	function link($scope, element) {
		var callback = $scope.dropareaCallback();
		var dataKey = $scope.dropareaDataKey || "dropareaData";

		element.droppable({
			accept: $scope.droparea,
			tolerance: "pointer",
			hoverClass: dropareaHoveringClass,
			addClasses: false,
			over: function over(event, ui) {
				return ui.helper.addClass(droppableOverTargetClass);
			},
			out: function out(event, ui) {
				return ui.helper.removeClass(droppableOverTargetClass);
			},
			drop: function drop(event, ui) {
				$scope.$apply(function apply() {
					callback(ui.helper.data(dataKey));
				});
			},
		});

		$scope.$on("$destroy", function onDestroy() {
			element.droppable("destroy");
		});
	}
});
